import React from 'react';

import {Loader} from '@optimaxdev/design-system';
import {createPortal} from 'react-dom';

import s from './placingOrderScreen.scss';

/**
 * "Placing Order" overlay component
 * @constructor
 */
export const PlacingOrderScreen = () =>
    createPortal(
        <div className={s.lockScreen}>
            <p>Placing order</p>
            <Loader className={s.loader} />
        </div>,
        document.body,
    );
